import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-management',
  templateUrl: './psa-management.component.html',
  styleUrls: ['./psa-management.component.css']
})
export class PsaManagementComponent implements OnInit {
  title="Management Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-management/psa-management.component.ts